import React from 'react';
import { Chip } from '@mui/material';

const statusConfig = {
  // Pipeline statuses
  active: { color: 'success', label: 'Active' },
  inactive: { color: 'default', label: 'Inactive' },
  draft: { color: 'default', label: 'Draft' },

  // Run statuses
  running: { color: 'info', label: 'Running' },
  completed: { color: 'success', label: 'Completed' },
  success: { color: 'success', label: 'Success' },
  failed: { color: 'error', label: 'Failed' },
  error: { color: 'error', label: 'Error' },
  pending: { color: 'warning', label: 'Pending' },
  queued: { color: 'warning', label: 'Queued' },
  cancelled: { color: 'default', label: 'Cancelled' },
  skipped: { color: 'default', label: 'Skipped' },

  // Alert statuses
  critical: { color: 'error', label: 'Critical' },
  warning: { color: 'warning', label: 'Warning' },
  info: { color: 'info', label: 'Info' },
  resolved: { color: 'success', label: 'Resolved' },

  // Generic
  enabled: { color: 'success', label: 'Enabled' },
  disabled: { color: 'default', label: 'Disabled' },
};

const StatusBadge = ({ status, size = 'small', variant = 'outlined', label: overrideLabel }) => {
  const key = (status || '').toLowerCase();
  const config = statusConfig[key] || { color: 'default', label: status || 'Unknown' };

  return (
    <Chip
      label={overrideLabel || config.label}
      color={config.color}
      size={size}
      variant={variant}
    />
  );
};

export default StatusBadge;
